<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe</label>
      </div>
      <select v-model="dataForm.equipe_id"
              class="custom-select"
              name="classement_equipe">
        <option :value="classement.equipe_id">
          {{ equipes ?
            (equipes.filter((equipe) => equipe.equipe_id === classement.equipe_id)[0].nom) :
            'Choisissez une équipe...' }}
        </option>
        <option :value="classement.equipe_id">-------------------------------------</option>
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Matchs Joués (J)</label>
      </div>
      <input v-model="dataForm.matchs_joues_j"
             class="form-control"
             name="classement_matchs_joues_j"
             placeholder="Entrez le nombre de matchs joués"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Matchs Gagnés (G)</label>
      </div>
      <input v-model="dataForm.matchs_gagnes_g"
             class="form-control"
             name="classement_matchs_gagnes_g"
             placeholder="Entrez le nombre de matchs gagnés"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Matchs Perdus (P)</label>
      </div>
      <input v-model="dataForm.matchs_perdus_p"
             class="form-control"
             name="classement_matchs_perdus_p"
             placeholder="Entrez le nombre de matchs perdus"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Matchs Nulles (N)</label>
      </div>
      <input v-model="dataForm.matchs_nulles_n"
             class="form-control"
             name="classement_matchs_nulles_n"
             placeholder="Entrez le nombre de matchs nulles"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Buts Marqués (GP)</label>
      </div>
      <input v-model="dataForm.buts_marques_gp"
             class="form-control"
             name="classement_buts_marques_gp"
             placeholder="Entrez le nombre de buts marqués"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Buts Encaissés (GC)</label>
      </div>
      <input v-model="dataForm.buts_encaisses_gc"
             class="form-control"
             name="classement_buts_encaisses_gc"
             placeholder="Entrez le nombre de buts encaissés"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Points (PTS)</label>
      </div>
      <input v-model="dataForm.points_pts"
             class="form-control"
             name="classement_points_pts"
             placeholder="Entrez le nombre de points"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Différence des buts (GD)</label>
      </div>
      <input v-model="dataForm.difference_buts_gd"
             class="form-control"
             name="classement_difference_buts_gd"
             placeholder="Entrez la différence des buts"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Saison</label>
      </div>
      <select v-model="dataForm.saison_id"
              class="custom-select"
              name="classement_saison">
        <option :key="saison.saison_id"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select v-model="dataForm.championnat_id"
              class="custom-select"
              name="classement_championnat">
        <option :value="classement.championnat_id">
          {{ championnats ?
            (championnats.filter((championnat) => championnat.championnat_id === classement.championnat_id)[0].nom) :
            'Choisissez un championnat...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="championnat.championnat_id"
                :value="championnat.championnat_id"
                v-for="championnat in championnats">
          {{ championnat.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Position</label>
      </div>
      <input v-model="dataForm.position"
             class="form-control"
             name="classement_position"
             placeholder="Entrez la position de l'équipe dans le classement"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    classement: {
      type: Object
    }
  },
  data() {
    return {
      championnats: null,
      saisons: null,
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        equipe_id: '',
        matchs_joues_j: '',
        matchs_gagnes_g: '',
        matchs_perdus_p: '',
        matchs_nulles_n: '',
        buts_marques_gp: '',
        buts_encaisses_gc: '',
        points_pts: '',
        difference_buts_gd: '',
        saison_id: '',
        championnat_id: '',
        position: '',
        table: 'classements',
        table_id: this.classement.classement_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Classement modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification du classement !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification du classement !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.equipe_id === '')
        this.dataForm.equipe_id = this.classement.equipe_id
      if(this.dataForm.matchs_joues_j === '')
        this.dataForm.matchs_joues_j = this.classement.matchs_joues_j
      if(this.dataForm.matchs_gagnes_g === '')
        this.dataForm.matchs_gagnes_g = this.classement.matchs_gagnes_g
      if(this.dataForm.matchs_perdus_p === '')
        this.dataForm.matchs_perdus_p = this.classement.matchs_perdus_p
      if(this.dataForm.matchs_nulles_n === '')
        this.dataForm.matchs_nulles_n = this.classement.matchs_nulles_n
      if(this.dataForm.buts_marques_gp === '')
        this.dataForm.buts_marques_gp = this.classement.buts_marques_gp
      if(this.dataForm.buts_encaisses_gc === '')
        this.dataForm.buts_encaisses_gc = this.classement.buts_encaisses_gc
      if(this.dataForm.points_pts === '')
        this.dataForm.points_pts = this.classement.points_pts
      if(this.dataForm.difference_buts_gd === '')
        this.dataForm.difference_buts_gd = this.classement.difference_buts_gd
      if(this.dataForm.saison_id === '')
        this.dataForm.saison_id = this.classement.saison_id
      if(this.dataForm.championnat_id === '')
        this.dataForm.championnat_id = this.classement.championnat_id
      if(this.dataForm.position === '')
        this.dataForm.position = this.classement.position
    },
    setDefaultValues() {
      const classement = Object.assign({}, this.classement);
      this.dataForm.equipe_id = classement.equipe_id
      this.dataForm.matchs_joues_j = classement.matchs_joues_j
      this.dataForm.matchs_gagnes_g = classement.matchs_gagnes_g
      this.dataForm.matchs_perdus_p = classement.matchs_perdus_p
      this.dataForm.matchs_nulles_n = classement.matchs_nulles_n
      this.dataForm.buts_marques_gp = classement.buts_marques_gp
      this.dataForm.buts_encaisses_gc = classement.buts_encaisses_gc
      this.dataForm.points_pts = classement.points_pts
      this.dataForm.difference_buts_gd = classement.difference_buts_gd
      this.dataForm.saison_id = classement.saison_id
      this.dataForm.championnat_id = classement.championnat_id
      this.dataForm.position = classement.position
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classements/components/Update.vue